import { useEffect } from 'react';

import { tableStore } from '../stores/table-store';
import { applyTableStoreRouteSync } from '../stores/utils/table-store-route-sync';
import { useProStudioCtxSelector } from '../xstate/app.xstate';
import { useCurrentRoute } from './use-current-route';
import { ProStudioPages } from './use-pro-studio-routes';

export const useTableStoreSync = () => {
  // console.log('=====================TableStore sync=====================');

  const isHomePage = useCurrentRoute().label === ProStudioPages.HOME;
  const isConfigurationsPage =
    useCurrentRoute().label === ProStudioPages.CONFIGURATIONS;
  const isWorkflowsPage = useCurrentRoute().label === ProStudioPages.WORKFLOWS;

  const isFirstLevelPage =
    isHomePage || isConfigurationsPage || isWorkflowsPage;

  const { draftVersion, botId, projectId, solutionVersionId } =
    useProStudioCtxSelector((ctx) => ({
      draftVersion: ctx.draftVersion,
      projectId: ctx.project?.projectProStudioSetting?.id,
      // Resolved in loadBotVersions against `isUsingUpdatedId`, not rebuilt here —
      // the key form is a property of the row, not something derivable from the version.
      solutionVersionId: ctx.solutionVersionPsId ?? '',
      botId:
        ctx.customerId && ctx.botName
          ? `${ctx.customerId}.${ctx.botName}`
          : undefined,
    }));

  // PSTUDIO-2998: push the dynamically-loaded native action-node command names
  // (system + library) into the MobX store, where the compiler and command picker
  // read them. setActionNodeNames guards equal lists, so this is a no-op churn
  // when unchanged.
  const actionNodeNames = useProStudioCtxSelector((ctx) => ctx.actionNodeNames);

  useEffect(() => {
    if (actionNodeNames && actionNodeNames.length) {
      tableStore.setActionNodeNames(actionNodeNames);
    }
  }, [actionNodeNames]);

  useEffect(() => {
    applyTableStoreRouteSync(tableStore, {
      isWorkflowsPage,
      isFirstLevelPage,
      draftVersion,
      botId,
      projectId,
      solutionVersionId,
    });
  }, [
    solutionVersionId,
    draftVersion,
    botId,
    projectId,
    isFirstLevelPage,
    isWorkflowsPage,
  ]);
};
